module.exports = __webpack_public_path__ + "img/LIGHTING 1 GREEN.00d5933.svg";